module.exports = __webpack_public_path__ + "static/img/banner.3cad17dc.jpg";